import { api } from 'config'

export const SEO_URL = {
   getPages: `${api.public}v1/seodata`,
   createPage: `${api.public}v1/seodata`,
   editPage: (_id: string) => `${api.public}v1/seodata/${_id}`
}
